import './index.scss';

const BackDrop = () => <div className="backdrop"></div>;

export { BackDrop };
